module.exports = __webpack_public_path__ + "static/media/toaster.test.js.a663cf3f.snap";